module.exports = __webpack_public_path__ + "static/39FEA2_6_0-ae58d69b21e7c9022425f132515cd0df.woff2";